import { expValEqualsNoExposure } from '@confluence/feature-experiments';
import { componentWithCondition } from '@confluence/feature-gating-utils';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EditorControlsFeedbackCollector as EditorControlsFeedbackCollectorSync } from './EditorControlsFeedbackCollector';

export const EditorControlsFeedbackCollectorAsync = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorControlsFeedbackCollector" */ './EditorControlsFeedbackCollector'
			)
		).EditorControlsFeedbackCollector,
});

export const EditorControlsFeedbackCollector = componentWithCondition(
	() => expValEqualsNoExposure('platform_editor_controls_performance_fixes', 'isEnabled', true),
	EditorControlsFeedbackCollectorAsync,
	EditorControlsFeedbackCollectorSync,
);
